import { Toaster } from "react-hot-toast"
import Layout from "../../shared/Layout"
import DataTable from "react-data-table-component"
import { useEffect, useState } from "react"
import { GetProductOrderDetail, GetProductOrderDetailMonthly } from "../../../_services";
import './orderreport.css';
import BarChart from "./BarChart"
import DoughnutChart from "./DoughnutChart";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Tooltip } from 'antd';
import { handleExport } from "../../../_services/excelExportService";

const OrderReport = () => {
    const [orderData, setOrderData] = useState([]);
    // const loginId = localStorage.getItem('loginId');
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [overallTotalAmount, setOverallTotalAmount] = useState(0);
    const [orderDataByStatusIdSussess, setOrderDataByStatusIdSussess] = useState([]);
    const [orderDataByStatusIdPending, setOrderDataByStatusIdPending] = useState([]);
    const [orderDataByDeliveryStatusY, setOrderDataByDeliveryStatusY] = useState([]);
    const [orderDataByDeliveryStatusN, setOrderDataByDeliveryStatusN] = useState([]);
    const [orderDataMonthly, setOrderDataMonthly] = useState([]);

    const fetchProductOrderByLoginId = async () => {
        try {
            const response = await GetProductOrderDetail();

            if (response.isSuccess === 200) {

                const orders = response.data;
                const sanitizedOrders = orders.map(order => ({
                    ...order,
                    totalAmount: parseFloat(order.orderAmount) || 0,
                }));

                const total = sanitizedOrders.reduce(
                    (sum, order) => sum + order.orderAmount,
                    0
                );

                setOverallTotalAmount(total);

                setOrderData((prevData) => {
                    if (JSON.stringify(prevData) !== JSON.stringify(orders)) {
                        const sortedData = orders?.sort((a, b) => {
                            return new Date(b.createdDate) - new Date(a.createdDate);
                        });
    
                        return sortedData;
                    }
                    return prevData;
                })

            } else {
                setError(response.message || 'Login failed. Please check your credentials.');
            }
        } catch (error) {
            setError('An error occurred. Please try again later.');
            setLoading(false);
        }
    };

    const fetchProductOrderDetailMonthly = async () => {
        const response = await GetProductOrderDetailMonthly();
        if (response.isSuccess === 200) {

            setOrderDataMonthly(response.data);

        } else {
            setError(response.message);
        }
    };

    useEffect(() => {
        fetchProductOrderDetailMonthly();
        fetchProductOrderByLoginId();
    }, []);

    useEffect(() => {
        if (searchTerm) {
            const filtered = orderData.filter(item => {
                const searchValue = searchTerm.toLowerCase();
                return (
                    item.orderId.toString().toLowerCase().includes(searchValue) ||
                    item.totalAmount.toString().toLowerCase().includes(searchValue) ||
                    item.discount.toString().toLowerCase().includes(searchValue) ||
                    item.deliveryStatus.toLowerCase().includes(searchTerm.toLowerCase())
                );
            });
            setFilteredData(filtered);
        } else {
            setFilteredData(orderData);
        }
    }, [searchTerm, orderData]);


    useEffect(() => {
        if (Array.isArray(orderData)) {
            // Filter orders where orderStatusId is 3
            const filteredStatusId3 = orderData.filter(item => item.orderStatusId === 3 || item.orderStatusId === 5);
            const filteredStatusId1 = orderData.filter(item => item.orderStatusId === 1 || item.orderStatusId === 4);
            const filteredDeliveryStatusY = orderData.filter(item => item.deliveryStatus === 'Y');
            const filteredDeliveryStatusN = orderData.filter(item => item.deliveryStatus === 'N');

            // Calculate the total of the orderAmount for orders with statusId 3
            const totalStatusId3 = filteredStatusId3.reduce((sum, item) => {
                const orderAmount = parseFloat(item.orderAmount) || 0;
                return sum + orderAmount;
            }, 0);

            // Calculate the total of the orderAmount for orders with statusId 1
            const totalStatusId1 = filteredStatusId1.reduce((sum, item) => {
                const orderAmount = parseFloat(item.orderAmount) || 0;
                return sum + orderAmount;
            }, 0);

            // Update state with calculated totals
            setOrderDataByStatusIdSussess(totalStatusId3.toFixed(2));
            setOrderDataByStatusIdPending(totalStatusId1.toFixed(2));
            setOrderDataByDeliveryStatusY(filteredDeliveryStatusY.length)
            setOrderDataByDeliveryStatusN(filteredDeliveryStatusN.length)
        }
    }, [orderData]);

    const excelSheetData = orderData.map((item, index) => ({
        Index: index + 1, 
        OrderNo: item.orderNo,
        TotalAmount: item.totalAmount,
        Discount: item.discount,
        TaxAmount: item.taxAmount,
        DeliveryStatus: item.deliveryStatus,
        ShippingCharge: item.shippingCharge,
    }));

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '70px'
        },
        {
            name: 'Order ID',
            cell: row => row.orderId,
            selector: row => row.orderNo,
            sortable: false
        },
        {
            name: 'Total Amount',
            cell: row => row.totalAmount,
            sortable: false
        },
        {
            name: 'Product Discount',
            cell: row => row.discount,
            sortable: false
        },
        {
            name: 'Shipping Charge',
            cell: row => 0,
            sortable: false
        },
        {
            name: 'VAT/TAX',
            cell: row => row.taxAmount,
            sortable: false
        },
        {
            name: 'Status',
            cell: row => (
                <span>
                    {row.deliveryStatus}
                </span>
            ),
            sortable: false,
        }
    ];

    return (
        <Layout>
            <div className="px-4 my-4">
                <div className="admin-page d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading d-flex align-items-center" style={{ gap: "10px" }}>
                        <img src="./images/order_report.png" style={{ width: '25px' }} alt="" />
                        <h4 className="mb-0">Order Report</h4>
                    </div>
                </div>
                <div className="order_report_wepper mt-3">
                    {/* <div className="card mb-2">
                        <div className="pb-0 filter_heading">
                            <h5 className="mb-3 ">Filter Data</h5>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 col-md-4 col-sm-3">
                                <select name="cars" id="cars">
                                    <option value="This Year">This Year</option>
                                    <option value="saab">This Month</option>
                                    <option value="opel">This Week</option>
                                </select>
                            </div>
                            <div className="col-lg-3 col-md-4 col-sm-3">
                                <button type="submit" className="filter_btn">
                                    Filter
                                </button>
                            </div>
                        </div>
                    </div> */}
                    <div className="container-fluid">
                        <div className="row order_report_colom_set_only">
                            <div className="col-lg-3 col-md-12 col-sm-3 p-0">
                                <div className="left-content-card_wepper mb-2">
                                    <div className="left-content-card">
                                        <img src="https://jaipurtouch.com/public/assets/back-end/img/cart.svg" alt="back-end/img" />
                                        <div className="info">
                                            <h4 className="subtitle">{orderData?.length}</h4>
                                            <h6 className="subtext">Total Orders</h6>
                                        </div>
                                    </div>
                                    <div className="coupon__discount ">
                                        <div className="text-center">
                                            <strong className="text-danger">{orderDataByDeliveryStatusN}</strong>
                                            <div className="Canceled_inner">
                                                <span>Canceled</span>
                                                <Tooltip placement="top" title='This Count is the Summation of Filed to Deliver, Canceled and Returned Order' >
                                                    <img className="info-img" src="https://jaipurtouch.com/public/assets/back-end/img/info-circle.svg" alt="img" />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        {/* <div className="text-center">
                                            <strong className="text-primary">4</strong>
                                            <div className="Canceled_inner">
                                                <span>Ongoing</span>
                                                <img className="info-img" src="https://jaipurtouch.com/public/assets/back-end/img/info-circle.svg" alt="img" />
                                            </div>
                                        </div> */}
                                        <div className="text-center">
                                            <strong className="text-success">{orderDataByDeliveryStatusY}</strong>
                                            <div className="Canceled_inner">
                                                <span>Completed  </span>
                                                <Tooltip placement="top" title='This Count is the Summation of Delivered Order' >
                                                    <img className="info-img" src="https://jaipurtouch.com/public/assets/back-end/img/info-circle.svg" alt="img" />
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="left-content-card_wepper ">
                                    <div className="left-content-card">
                                        <img src="https://jaipurtouch.com/public/assets/back-end/img/cart.svg" alt="back-end/img" />
                                        <div className="info">
                                            <h4 className="subtitle"> ₹{overallTotalAmount.toFixed(2)}</h4>
                                            <h6 className="subtext">Total Order Amount                                            </h6>
                                        </div>
                                    </div>
                                    <div className="coupon__discount ">
                                        <div className="text-center">
                                            <strong className="text-danger">₹{orderDataByStatusIdPending}</strong>
                                            <div className="Canceled_inner">
                                                <span>Due Amount</span>
                                                <Tooltip placement="top" title='The ongoing order amount shown here' >
                                                    <img className="info-img" src="https://jaipurtouch.com/public/assets/back-end/img/info-circle.svg" alt="img" />
                                                </Tooltip>
                                            </div>
                                        </div>

                                        <div className="text-center">
                                            <strong className="text-success">₹{orderDataByStatusIdSussess}</strong>
                                            <div className="Canceled_inner">
                                                <span>Already Settled                                                </span>
                                                <Tooltip placement="top" title='After the Order Delivered total order amount will be shown here' >
                                                    <img className="info-img" src="https://jaipurtouch.com/public/assets/back-end/img/info-circle.svg" alt="img" />
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-lg-5 col-md-12 col-sm-4 mt-xl-0 mt-2">
                                <div className="center-chart-area">
                                    <div className="center-chart-header">
                                        <h3 className="title">Order Statistics</h3>
                                    </div>
                                    <div className="bar_chart">
                                        <BarChart
                                            orderDataMonthly={orderDataMonthly}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12 col-sm-3 px-0 mt-2">
                                <div className="payment-statistics-shadow">
                                    <h2>Payment Statistics</h2>
                                    <div className="bar_chart">
                                        <DoughnutChart
                                            orderData={orderData}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="datatable mt-4">

                    <>
                        <div className="d-flex justify-content-between">
                            <div className="d-flex align-items-center mb-3" style={{ gap: '10px' }}>
                                <h5 className="mb-0">Total Orders</h5>
                                <span className="order_length">{orderData?.length}</span>
                            </div>
                            <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                <div className="search-container ">
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="form-control"
                                    />
                                </div>
                                <button className="export_button" onClick={() => handleExport(excelSheetData)}><img src="./images/upload.png" alt="" className="export_icon" /><span>Export</span></button>
                            </div>
                        </div>
                        <DataTable
                            columns={columns}
                            data={filteredData || []}
                            progressPending={loading}
                            progressComponent={<p>Loading...</p>}
                            pagination
                            highlightOnHover
                        />
                    </>

                </div>
                {loading ? <p>Loading...</p> : null}
                <Toaster position="top-right" />
            </div>
        </Layout>
    )
}
export default OrderReport